import {ScoNavItem, Manifest, ManifestVersionChecker} from "../scorm/manifest";
export {UrlVarService} from "../url";
import {ScormPlugin, ScormPluginBase} from "../scorm/plugin";
import {Scorm12Plugin} from "../12/plugin";
import {Scorm2004Plugin} from "../2004/plugin";
import {Scorm2004SimplePlugin} from "../2004simple/plugin";
import {SSLAApiEvents} from "../scorm/events";
import {SSLAPlugin} from "../plugin";
import {ScormLog} from "../scorm/scormlog";
import * as Path from "../path";
import * as Message from "../message";

declare var reqwest: any;


export class ScormAllVersionsPlugin extends SSLAPlugin implements ScormPlugin {
    assetCached: boolean = false;
    events: SSLAApiEvents;
    mvc: ManifestVersionChecker;
    scormLog: ScormLog;
    scormPlugin: ScormPluginBase;

    constructor(events: SSLAApiEvents=null) {
        super();
        if (events) {
            this.events = events;
        }
        else {
            this.events = new SSLAApiEvents();
        }
    }

    checkManifestVersion(): boolean {
        this.mvc = new ManifestVersionChecker();
        let res:any;
        if (this.config.scormManifestUseRawXml()) {
            res = this.mvc.loadScormManifestFromString(this.config.scormManifestRawXml());
        }
        else {
            res = this.mvc.loadScormManifestFromDom(this.contents);
        }

        if (res === false) {
            return null;
        }

        if (this.mvc.schemaVersionMain == "1.2") {
        }
        else if (this.mvc.schemaVersionMain == "2004") {
        }
        else {
            return null;
        }
    }

    cleanup() {
        this.scormPlugin.cleanup();
    }

    closeActiveContent() {
        this.scormPlugin.closeActiveContent();
    }

    createManifestClass(): Manifest {
        // NOOP
        return null;
    }

    initializeApi(scoNav: ScoNavItem) {
        this.scormPlugin.initializeApi(scoNav);
    }

    endPreviousSco() {
        this.scormPlugin.endPreviousSco();
    }

    finish() {
        this.scormPlugin.finish();
    }

    initializeScosData() {
        this.scormPlugin.initializeScosData();
    }

    interstitialReady() {
        this.scormPlugin.interstitialReady();
    }

    initializeSequencing() {
        this.scormPlugin.initializeSequencing();
    }

    navigate(type: string) {
        this.scormPlugin.navigate(type);
    }

    navigateByIdentifier(id: string) {
        this.scormPlugin.navigateByIdentifier(id);
    }

    loadSco(scoNav: ScoNavItem, scoIndex: number) {
        this.scormPlugin.loadSco(scoNav, scoIndex);
    }

    loadScoByIdentifier(scoId: string) {
        this.scormPlugin.loadScoByIdentifier(scoId);
    }

    performLayoutUpdate() {
        this.scormPlugin.performLayoutUpdate();
    }

    setupNavigationType() {
        this.scormPlugin.setupNavigationType();
    }

    standardLayoutUpdater() {
        this.scormPlugin.standardLayoutUpdater();
    }

    updateManifestSelectability() {
        this.scormPlugin.updateManifestSelectability();
    }

    updateRollupScore() {
        this.scormPlugin.updateRollupScore();
    }

    updateRollupStatus() {
        this.scormPlugin.updateRollupStatus();
    }

    // TODO This one is only for bindable behavior, and each plugin will have bound it internally.  Probably shouldn't be part of the interface.
    onceLoaded() {
        this.scormPlugin.onceLoaded();
    }

    loadAfterMainAsset() {
        this.checkManifestVersion();
        if (!this.mvc) {
            Message.show(this.config, Message.Error,"The manifest (imsmanifest.xml) was not found or is unavailable.  Please check your settings and try again.");
            return;
        }

        if (this.mvc.schemaVersionMain === "1.2") {
            this.scormPlugin = new Scorm12Plugin(this.events);
        }
        else if (this.mvc.schemaVersionMain === "2004") {
            if (this.config.scorm2004Mode() == "simple") {
                this.scormPlugin = new Scorm2004SimplePlugin(this.events);
            }
            else {
                this.scormPlugin = new Scorm2004Plugin(this.events);
            }
        }
        else {
            Message.show(this.config, Message.Error,"The SCORM version could not be determined for manifest (imsmanifest.xml), please review your SCORM package.");
            return;
        }
        this.scormPlugin.assetCached = true;
        this.scormPlugin.contents = this.contents;
        this.scormPlugin.config = this.config;
        this.scormPlugin.ctd = this.ctd;
        this.scormPlugin.mvc = this.mvc;
        this.scormPlugin.start();
    }

    start() {
        if (!this.assetCached) {
            this.getMainAsset(this.loadAfterMainAsset.bind(this));
        }
        else {
            this.loadAfterMainAsset();
        }
    }

    getMainAsset(callbackOnDecision: Function) {
        let me = this;
        reqwest({
            url: Path.join([me.config.courseDirectory(), me.config.scormManifestFilename()])
            , type: 'xml'
        })
            .then(function (resp: any) {
                me.assetCached = true;
                me.contents = resp;
            })
            .always(function (resp: any) {
                me.checked = true;
                callbackOnDecision();
            });
    }

}

